import { useCallback, useEffect, useState } from "react";
import { fetchProduct } from "../api/catalog";
import { useCart } from "../cart/CartContext";
import VariantPicker from "./VariantPicker";
import { formatMoney } from "../lib/money";
import { storePath } from "../lib/storePaths";

export default function ProductOffer({ block, storeSlug, className = "" }) {
  const { addItem } = useCart();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(Boolean(block.productHandle));
  const [variant, setVariant] = useState(null);
  const onVariant = useCallback((next) => setVariant(next), []);
  const handle = block.productHandle;

  useEffect(() => {
    if (!handle) return undefined;
    const controller = new AbortController();
    setLoading(true);
    fetchProduct(storeSlug, handle, { signal: controller.signal })
      .then((result) => setProduct(result?.product || null))
      .catch((error) => {
        if (error?.name !== "AbortError") setProduct(null);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [handle, storeSlug]);

  if (!handle) return null;
  if (loading && !product) return null;
  if (!product) return null;

  const image = product.primaryImage || product.images?.[0]?.url;
  const amount = Number(variant?.amountMinor);
  const compare = Number(variant?.compareAtAmountMinor);
  const productUrl = storePath(`/products/${product.handle}`, storeSlug);
  const outOfStock = variant?.stockStatus === "out_of_stock";

  return (
    <div className={`${className} home-offer`}>
      {image ? <img src={image} alt={product.images?.[0]?.altText || product.title} /> : null}
      <div className="home-offer__body">
        <h3>{product.title}</h3>
        {product.variants?.length ? (
          <VariantPicker variants={product.variants} onChange={onVariant} />
        ) : null}
        {variant ? (
          <p className="home-offer__price">
            {compare > amount ? <s>{formatMoney(compare, variant.currency)}</s> : null}
            <strong>{formatMoney(amount, variant.currency)}</strong>
          </p>
        ) : null}
        {block.note ? <p>{block.note}</p> : null}
        <button
          type="button"
          className="add-to-cart-button"
          disabled={!variant || outOfStock}
          onClick={() => addItem(product, variant)}
        >
          {outOfStock ? "Produto indisponível" : block.buttonLabel || "Comprar"}
        </button>
        <a href={productUrl}>Ver produto</a>
      </div>
    </div>
  );
}
